/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenerateGatewayPaymentQRResponse } from '../models/GenerateGatewayPaymentQRResponse';
import type { InstallmentPlanDto } from '../models/InstallmentPlanDto';
import type { LiffContactInfo } from '../models/LiffContactInfo';
import type { LiffUserLinkCheckResult } from '../models/LiffUserLinkCheckResult';
import type { LiffUserLinkRequest } from '../models/LiffUserLinkRequest';
import type { LineOaFinancierLiffUser } from '../models/LineOaFinancierLiffUser';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LiffFinancierService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Check LIFF account connection
     * @returns LiffUserLinkCheckResult OK
     * @throws ApiError
     */
    public checkLineOaFinancierLiffUserLinked({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<LiffUserLinkCheckResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/liff/financiers/{financierId}/link',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Link LIFF account
     * @returns LineOaFinancierLiffUser OK
     * @throws ApiError
     */
    public linkLineOaFinancierLiffUser({
        financierId,
        requestBody,
    }: {
        financierId: string,
        requestBody: LiffUserLinkRequest,
    }): CancelablePromise<LineOaFinancierLiffUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/public/liff/financiers/{financierId}/link',
            path: {
                'financierId': financierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Unlink LIFF account
     * @returns any OK
     * @throws ApiError
     */
    public unlinkLineOaFinancierLiffUser({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/public/liff/financiers/{financierId}/link',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get LIFF financier user profile
     * @returns LineOaFinancierLiffUser OK
     * @throws ApiError
     */
    public getLineOaFinancierLiffUser({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<LineOaFinancierLiffUser> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/liff/financiers/{financierId}/user',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get LIFF financier user installment plans
     * @returns InstallmentPlanDto OK
     * @throws ApiError
     */
    public getLineOaFinancierLiffUserInstallmentPlans({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<Array<InstallmentPlanDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/liff/financiers/{financierId}/installment-plan',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Generate QR for LIFF financier user installment plan
     * @returns GenerateGatewayPaymentQRResponse OK
     * @throws ApiError
     */
    public generateLineOaFinancierLiffUserInstallmentPlanPaymentQr({
        financierId,
        installmentPlanId,
    }: {
        financierId: string,
        installmentPlanId: string,
    }): CancelablePromise<GenerateGatewayPaymentQRResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/liff/financiers/{financierId}/installment-plan/{installmentPlanId}/pay/generate-qr',
            path: {
                'financierId': financierId,
                'installmentPlanId': installmentPlanId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get LIFF financier contact info
     * @returns LiffContactInfo OK
     * @throws ApiError
     */
    public getLineOaFinancierContactInfo({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<LiffContactInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/liff/financiers/{financierId}/contact-info',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
